export default "__VITE_ASSET__29dc5741__"